// core
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';

// Campfire
import { PartnerBrandService } from '@campfire-nx/api';

// Services
import { RaptorAnalyticsService } from '../../../services/raptor-analytics.service';
import { RaptorStepService } from '../../../services/raptor-step.service';

@Component({
  selector: 'open-raptor-page-offramp',
  templateUrl: './raptor-page-offramp.component.html',
  styleUrls: ['./raptor-page-offramp.component.scss']
})
export class RaptorPageOfframpComponent implements OnInit {
  @Input() formData: any;
  @Input() form!: FormGroup;

  layoutSettings: any = {};
  cardLeadOff!: boolean;
  bannerHeaders!: any;
  autoRedirectTimer: number = -1;
  raptorStepSubscription!: Subscription;
  disclaimers?: Array<any> = [];

  constructor(
    public raptorStepService: RaptorStepService,
    private raptorAnalyticsService: RaptorAnalyticsService,
    private partnerBrandService: PartnerBrandService
  ) { }

  ngOnInit(): void {
    this.setLayout(this.formData.settings);
    if (this.formData.banners?.length) {
      this.bannerHeaders = this.formData.banners.filter((banner: any) => banner.type === 'header');
      this.bannerHeaders.forEach((banner: any) => this.disclaimers?.push({ type: 'banner', content: banner.disclaimer }));
    }
  }

  ngAfterViewInit(): void {
    const redirect_time = (this.formData.settings && this.formData.settings.redirect_time_milliseconds);
    if (this.formData.actions && this.formData.actions.next && redirect_time && parseInt(redirect_time) > 0) {
      this.autoRedirectTimer = window.setTimeout(() => { this.onRedirect(); }, redirect_time);
    }
  }

  ngOnDestroy(): void {
    if (this.raptorStepSubscription) {
      this.raptorStepSubscription.unsubscribe();
    }
  }

  setLayout(settings: any) {
    this.layoutSettings = settings || {};
    if (this.formData.sidebar) {
      this.layoutSettings.sidebar = this.formData.sidebar;
    }

    this.cardLeadOff = false;
    if (this.formData.sections && this.formData.sections.length > 0){
      if (this.formData.sections[0].settings && this.formData.sections[0].settings.card) {
        this.cardLeadOff = true;
      }
    }
  }

  onRedirect() {
    this.raptorAnalyticsService.finishStep();
    if (this.autoRedirectTimer > -1) {
      clearTimeout(this.autoRedirectTimer);
    }
    if (this.partnerBrandService.data.redirectBack) {
      window.location.href = this.partnerBrandService.data.redirectBack;
    } else if (this.partnerBrandService.data.redirect) {
      window.location.href = this.partnerBrandService.data.redirect;
    } else {
      window.location.href = this.formData.actions.next;
    }
  }
}
